export interface AddAirportContractContact {
    mediaNo: number;
    mediaType: string;
    contact: string;
}